export default __webpack_public_path__ + "static/media/not-found.f4e6f577.png";